import apiClient from './apiClient';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Notifications API
export const getNotifications = async (unreadOnly = false) => {
  const response = await apiClient.get('/notifications', {
    params: { unread_only: unreadOnly }
  });
  return response.data;
};

export const getUnreadCount = async () => {
  const response = await apiClient.get('/notifications/unread-count');
  return response.data;
};

export const markNotificationRead = async (notificationId) => {
  const response = await apiClient.post(`/notifications/mark-read/${notificationId}`);
  return response.data;
};

export const markAllNotificationsRead = async () => {
  const response = await apiClient.post('/notifications/mark-all-read');
  return response.data;
};

// Consignments API
export const getConsignments = async (status = null, section = null) => {
  const params = {};
  if (status) params.status = status;
  if (section) params.section = section;
  
  const response = await apiClient.get('/consignments', { params });
  return response.data;
};

export const getIncomingConsignments = async () => {
  const response = await apiClient.get('/consignments/incoming');
  return response.data;
};

export const getShipmentRequests = async () => {
  const response = await apiClient.get('/consignments/shipment-requests');
  return response.data;
};

export const requestConsignment = async (entryId) => {
  const response = await apiClient.post(`/consignments/request/${entryId}`);
  return response.data;
};

export const rejectConsignment = async (entryId) => {
  const response = await apiClient.post(`/consignments/reject/${entryId}`);
  return response.data;
};

export const confirmShipment = async (entryId) => {
  const response = await apiClient.post(`/consignments/confirm-shipment/${entryId}`);
  return response.data;
};

export const confirmReceiptByScan = async (documentBarcode) => {
  const response = await apiClient.post(
    '/consignments/confirm-receipt',
    null,
    { params: { document_barcode: documentBarcode } }
  );
  return response.data;
};

export const getConsignmentBundles = async (entryId) => {
  const response = await apiClient.get(`/consignments/bundles/${entryId}`);
  return response.data;
};

// WebSocket connection for real-time notifications
export const createNotificationWebSocket = (userId, onMessage, onError) => {
  const wsUrl = BACKEND_URL.replace('https://', 'wss://').replace('http://', 'ws://');
  const ws = new WebSocket(`${wsUrl}/api/notifications/ws/${userId}`);
  
  ws.onopen = () => {
    console.log('WebSocket connected for notifications');
    // Start ping interval to keep connection alive
    const pingInterval = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.send('ping');
      } else {
        clearInterval(pingInterval);
      }
    }, 30000);
    ws._pingInterval = pingInterval;
  };
  
  ws.onmessage = (event) => {
    if (event.data === 'pong') return;
    try {
      const data = JSON.parse(event.data);
      onMessage(data);
    } catch (e) {
      console.error('Error parsing WebSocket message:', e);
    }
  };
  
  ws.onerror = (error) => {
    console.error('WebSocket error:', error);
    if (onError) onError(error);
  };
  
  ws.onclose = () => {
    console.log('WebSocket disconnected');
    if (ws._pingInterval) clearInterval(ws._pingInterval);
  };
  
  return ws;
};
